export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  // Merchant Selector
  'component.merchantSelector.noMerchants': 'No merchants available',
  'component.merchantSelector.addMerchant': 'Add New Merchant',
  'component.merchantSelector.setupMerchant': 'Setup Merchant',

  // Empty Merchants
  'components.emptyMerchants.title': 'Welcome to AimerPay!',
  'components.emptyMerchants.subtitle':
    "You haven't created any merchants yet. Let's get started by creating your first merchant account.",
  'components.emptyMerchants.createButton': 'Create Your First Merchant',
  'components.emptyMerchants.stepsTitle': 'Getting Started',
  'components.emptyMerchants.step1.title': 'Create Merchant Account',
  'components.emptyMerchants.step1.description':
    'Provide basic business information including legal name, country, and contact details.',
  'components.emptyMerchants.step2.title': 'Complete KYC Verification',
  'components.emptyMerchants.step2.description':
    'Submit required business documents through Adyen Hosted Onboarding for compliance verification.',
  'components.emptyMerchants.step3.title': 'Start Managing Payments',
  'components.emptyMerchants.step3.description':
    'Once verified, you can create stores, view transactions, process payouts, and manage your balance accounts.',
  'components.emptyMerchants.helpText':
    'Need help? Our support team is available to assist you with the onboarding process.',

  // Acting as MerchantOwner Banner
  'component.actingAsMerchantOwner.label': 'Acting as: {name}',
  'component.actingAsMerchantOwner.exit': 'Back to Admin',
};
